import { call, put, select } from "redux-saga/effects";

import { worker } from "legacy/sagas/evaluationLoader";
import { getWidgets } from "legacy/selectors/entitiesSelector";
import { EVAL_WORKER_ACTIONS } from "legacy/utils/DynamicBindingUtils";
import type { WidgetMap } from "legacy/widgets";
import apiDSLReplayManager from "legacy/workers/replay/ApiDSLReplayManager";
import { selectAllV2Apis } from "store/slices/apisV2/selectors";

import {
  setUndoStackIndexAtRequestStart,
  setStateAtRequestStart,
} from "../slice";

export function* doSetupBeforeClarkRequestSaga(action: {
  payload: { isRedo?: boolean };
}) {
  const isRedo = action.payload.isRedo ?? false;

  // Right now we only need to do this for the first request, not redo requests
  if (isRedo) {
    return;
  }

  const widgetsUndoStackLength: number = yield call(
    worker.request,
    EVAL_WORKER_ACTIONS.GET_UNDO_STACK_LENGTH,
    {},
  );
  const widgetsAtRequestStart: WidgetMap = yield select(getWidgets);

  // loop through all apis and get the undo stack length
  const currentAPIs: ReturnType<typeof selectAllV2Apis> =
    yield select(selectAllV2Apis);
  const apisUndoStackLengths = Object.keys(currentAPIs).reduce(
    (acc, apiId) => {
      acc[apiId] = apiDSLReplayManager.getUndoStackLength(apiId);
      return acc;
    },
    {} as Record<string, number>,
  );

  yield put(
    setUndoStackIndexAtRequestStart({
      widgetsUndoStackLength,
      apisUndoStackLengths,
    }),
  );

  // TODO: Ai team: We can likely just store the widgets and apis that we operating on
  // and not the entire state for widgets and apis
  yield put(
    setStateAtRequestStart({
      widgetsAtRequestStart: widgetsAtRequestStart,
      apisAtRequestStart: currentAPIs,
    }),
  );
}
